import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const BroadbandBeforePrequalTitle = props => {
  const renderContent = content => ({ __html: content });
  const theme = useTheme();
  return (
    <>
      <Typography
        component='h1'
        variant='h1'
        color={theme.palette.secondary.mobileActiveToggleBackground}
        sx={{
          ...styles(theme).beforePrequalBannerText,
          marginTop: props.sm && !props.ShowOfferImage && '5rem',
        }}
        dangerouslySetInnerHTML={renderContent(props.title)}
      />
      <Typography
        component='p'
        variant='subtitle3'
        color={theme.palette.secondary.mobileActiveToggleBackground}
        sx={{ ...(props.sm && { maxWidth: '290px' }) }}
        dangerouslySetInnerHTML={renderContent(props.subTitle)}
      />
    </>
  );
};

export default BroadbandBeforePrequalTitle;
